export default "__VITE_ASSET__BpmMWUTx__"